import React from 'react';
import { Stack, Button, Typography, Box, IconButton, Tooltip } from '@mui/material';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { ghostBtn } from '../uiKit';

// GetVacancies does not return links, so when a vacancy already has a public key
// they are rebuilt from the saved settings, exactly as the backend builds them.
export const buildLinks = (settings, publicKey) => {
    if (!settings?.siteBaseUrl || !settings?.careersName || !publicKey) return null;
    const liveUrl = `${settings.siteBaseUrl}/careers/${settings.careersName}/${publicKey}`;
    return { liveUrl, linkedIn: `${liveUrl}?src=linkedin`, naukri: `${liveUrl}?src=naukri` };
};

const copy = async (text, done) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch { /* nothing more to try */ }
        document.body.removeChild(ta);
    }
    done?.();
};

export default function CareersLinks({ links, compact = false, onCopied }) {
    if (!links?.liveUrl) {
        return compact ? (
            <Typography sx={{ fontSize: 11.5, color: '#98A0AE', mt: 0.4 }}>
                Set your website address in Careers settings to get shareable links.
            </Typography>
        ) : null;
    }
    const rows = [
        ['Careers page', links.liveUrl],
        ['Copy LinkedIn link', links.linkedIn],
        ['Copy Naukri link', links.naukri],
    ].filter(([, url]) => url);

    if (compact) {
        return (
            <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.6, mt: 0.6 }}>
                {rows.map(([label, url]) => (
                    <Button key={label} size="small" onClick={() => copy(url, onCopied)}
                        startIcon={<ContentCopyRoundedIcon sx={{ fontSize: 13 }} />}
                        sx={{ ...ghostBtn, height: 26, px: 1, fontSize: 11 }}>
                        {label === 'Careers page' ? 'Copy careers link' : label}
                    </Button>
                ))}
            </Stack>
        );
    }
    return (
        <Stack spacing={1}>
            {rows.map(([label, url]) => (
                <Box key={label} sx={{ p: 1.2, border: '1px solid #EEF1F6', borderRadius: '9px', bgcolor: '#F8FAFC' }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 800, color: '#6E6B99', textTransform: 'uppercase', letterSpacing: 0.5 }}>
                        {label.replace('Copy ', '').replace(' link', '')}
                    </Typography>
                    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
                        <Typography sx={{ fontSize: 12.5, color: '#334155', flex: 1, wordBreak: 'break-all' }}>{url}</Typography>
                        <Tooltip arrow title="Open"><IconButton size="small" component="a" href={url} target="_blank" rel="noreferrer"><OpenInNewRoundedIcon sx={{ fontSize: 16 }} /></IconButton></Tooltip>
                        <Button size="small" onClick={() => copy(url, onCopied)} startIcon={<ContentCopyRoundedIcon sx={{ fontSize: 14 }} />} sx={{ ...ghostBtn, height: 28, px: 1.2, fontSize: 11.5 }}>Copy</Button>
                    </Stack>
                </Box>
            ))}
        </Stack>
    );
}
